import { render } from "./InfoBasicasRepeticao.vue?vue&type=template&id=15f41840&scoped=true"
import script from "./InfoBasicasRepeticao.vue?vue&type=script&lang=js"
export * from "./InfoBasicasRepeticao.vue?vue&type=script&lang=js"

import "./InfoBasicasRepeticao.vue?vue&type=style&index=0&id=15f41840&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15f41840"]])

export default __exports__